"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MerkleTree_1 = __importDefault(require("./MerkleTree"));
var ethers_1 = require("ethers");
var BalanceTree = /** @class */ (function () {
    function BalanceTree(balances) {
        this.tree = new MerkleTree_1.default(balances.map(function (_a, index) {
            var account = _a.account, amount = _a.amount;
            return BalanceTree.toNode(index, account, amount);
        }));
    }
    BalanceTree.verifyProof = function (index, account, amount, proof, root) {
        var pair = BalanceTree.toNode(index, account, amount);
        for (var _i = 0, proof_1 = proof; _i < proof_1.length; _i++) {
            var item = proof_1[_i];
            pair = MerkleTree_1.default.combinedHash(pair, item);
        }
        return pair === root;
    };
    BalanceTree.toNode = function (index, account, amount) {
        return ethers_1.utils.solidityKeccak256(['uint256', 'address', 'uint256'], [index, account, amount]);
    };
    BalanceTree.prototype.getHexRoot = function () {
        return this.tree.getHexRoot();
    };
    BalanceTree.prototype.getProof = function (index, account, amount) {
        return this.tree.getProof(BalanceTree.toNode(index, account, amount));
    };
    return BalanceTree;
}());
exports.default = BalanceTree;
